export default __webpack_public_path__ + "static/Artboard-8-7e788b8d58840f8446b7447d49d62307.webp";